import { BaseApiClient } from '../BaseApiClient'

export default class ApplicationClient extends BaseApiClient {
  static async applicationList (params) {
    return this.get('application/list', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async statuses () {
    return await this.get('application/statuses', {
      headers: this.getAuthHeaders()
    }).then(response => response.data)
  }

  static async extraData() {
    return await this.get('application/extra-data', {
      headers: this.getAuthHeaders()
    }).then(response => response.data)
  }
}
